import { ax } from '../../AxiosFactory'

const setTradeinAnswer = async (info) => {
  const res = await ax.post('promotion/trade-in-user/', { info: info })
  return res
}

export { setTradeinAnswer }
